export const extractDomain = (url) => {
	try {
		const { hostname } = new URL(url);

		return hostname;
	} catch {
		return null;
	}
};
